import { createContext, ComponentProps, ComponentType, useContext } from 'react';

import Spinner from 'components/spinner';
import Layout from 'components/layout';
import DefaultSidebar from 'components/sidebar';
import Content from 'components/content';

const FallbackContext = createContext<ComponentType>( FallbackContent );

export function withFallback( FallbackComponent: ComponentType ) {
	return function DynamicFallbackComponent( Component: ComponentType ) {
		return function WithFallback( props: ComponentProps<typeof Component> ) {
			return (
				<FallbackContext.Provider value={ FallbackComponent }>
					<Component { ...props } />
				</FallbackContext.Provider>
			);
		};
	};
}

export function FallbackOutlet() {
	const FallbackComponent = useContext( FallbackContext );

	if ( ! FallbackComponent ) {
		return null;
	}

	return (
		<FallbackComponent />
	);
}

export function FallbackLayout( { Sidebar = DefaultSidebar }: { Sidebar?: ComponentType | null; } ) {
	return (
		<Layout Sidebar={ Sidebar }>
			<Content className="flex justify-center items-center">
				<Spinner big />
			</Content>
		</Layout>
	);
}

export function FallbackContent() {
	return (
		<div className="h-full flex justify-center items-center">
			<Spinner big />
		</div>
	);
}
